import { Outlet } from 'react-router-dom';
import { WebHeader } from './WebHeader';
import { WebFooter } from './WebFooter';

/** Storefront shell: sticky header + routed content + footer (bottom nav is global, in App). */
export function CustomerLayout() {
  return (
    <div className='flex min-h-screen flex-col bg-surface-content pb-14 font-sans text-content-primary'>
      <WebHeader />
      <main className='flex-1'>
        <Outlet />
      </main>
      <WebFooter />
    </div>
  );
}
